module.exports = {
    lowQuality: 1,
    normal: 2,
    highQuality: 3,
    magicallyEnhanced: 4,
    set: 5,
    rare: 6,
    unique: 7,
    crafted: 8
};



// WEBPACK FOOTER //
// ./src/components/character/item/quality.js